import { Column } from "primereact/column";
import { ScreeningPscInspection } from "../types/Screening";
import { round } from "lodash";
import { ScreeningPscInspectedBody } from "../components/screening/ScreeningPscInspectedBody";
import { ScreeningPscDetainedBody } from "../components/screening/ScreeningPscDetainedBody";
import { ScreeningPscPortBody } from "../components/screening/ScreeningPscPortBody";
import { ScreeningPscDurationBody } from "../components/screening/ScreeningPscDurationBody";
import { ScreeningPscDeficienciesBody } from "../components/screening/ScreeningPscDeficienciesBody";

export const getSummaryAggregates = (inspections: ScreeningPscInspection[]) => {
    let inspectionsTotal = 0;
    let deficienciesTotal = 0;
    let detentionsTotal = 0;
    let deficiencyPerInspection = 0;
    let detentionRate = 0;

    inspections.forEach((inspection) => {
        inspectionsTotal += 1;
        deficienciesTotal += inspection.number_of_deficiencies;

        if (inspection.detained === "Y") {
            detentionsTotal += 1;
        }
    });

    if (inspectionsTotal) {
        if (deficienciesTotal) {
            deficiencyPerInspection = round(
                deficienciesTotal / inspectionsTotal,
                2
            );
        }

        if (detentionsTotal) {
            detentionRate = round(
                (detentionsTotal / inspectionsTotal) * 100,
                2
            );
        }
    }

    return {
        inspectionsTotal,
        deficienciesTotal,
        detentionsTotal,
        deficiencyPerInspection,
        detentionRate
    };
};

export const pscInspectionColumns = () => [
    <Column
        key="date"
        field="date"
        frozen
        sortable
        header="Inspected"
        body={ScreeningPscInspectedBody}
        className="table-small-column"
    />,
    <Column
        key="number_of_deficiencies"
        field="number_of_deficiencies"
        frozen
        sortable
        header="Deficiencies"
        className="table-small-column table-right-border"
        headerClassName="table-right-border"
        body={ScreeningPscDeficienciesBody}
    />,
    <Column
        key="detained"
        field="detained"
        sortable
        header="Detained"
        body={ScreeningPscDetainedBody}
        className="table-small-column"
    />,
    <Column
        key="released_date"
        field="released_date"
        sortable
        header="Duration"
        body={ScreeningPscDurationBody}
        className="table-small-column"
    />,
    <Column
        key="mou"
        field="mou"
        sortable
        header="PSC organisation"
        className="table-large-column"
    />,
    <Column
        key="port"
        field="port"
        sortable
        header="Port of inspection"
        body={ScreeningPscPortBody}
        className="table-large-column"
    />
];
